import React from 'react';
import { View, Text } from 'react-native';

import Link from 'gatsby-link';

const styles = {
  holder: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 80,
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  list: {
    flexDirection: 'row'
  },
  dots: {
    marginHorizontal: 20,
    color: '#BBB'
  },
  links: {
    color: '#CCC',
    fontSize: 14,
    textDecoration: 'none'
  }
};

const Footer = ({ lang }) => (
  <View style={styles.holder}>
    <View style={styles.list}>
      <Link style={styles.links} to={`/${lang.CODE}/about`}>
        {lang.ABOUT.toUpperCase()}
      </Link>
      <Text style={styles.dots}> . </Text>
      <Link style={styles.links} to={`/${lang.CODE}/features`}>
        {lang.FEATURES.toUpperCase()}
      </Link>
      <Text style={styles.dots}> . </Text>
      <Link style={styles.links} to={`/${lang.CODE}/support`}>
        {lang.SUPPORT.toUpperCase()}
      </Link>
      <Text style={styles.dots}> . </Text>
      <Link style={styles.links} to={`/${lang.CODE}/terms`}>
        {lang.TERMS.toUpperCase()}
      </Link>
      <Text style={styles.dots}> . </Text>
      <Link style={styles.links} to={`/${lang.CODE}/contact`}>
        {lang.CONTACT.toUpperCase()}
      </Link>
    </View>
    <View style={styles.list}>
      <span style={styles.links}>{lang.COPYRIGHT}</span>
    </View>
  </View>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/comp/footer.js